export default {
  common: {
    app_name: 'Ví Của Tôi',
    loading: 'Đang tải...',
    save: 'Lưu',
    cancel: 'Hủy',
    confirm: 'Xác nhận',
    delete: 'Xóa',
    edit: 'Sửa',
    add: 'Thêm',
    search: 'Tìm kiếm',
    filter: 'Lọc',
    language: 'Ngôn ngữ',
    logout: 'Đăng xuất',
    error: 'Lỗi',
    success: 'Thành công',
    warning: 'Cảnh báo',
    info: 'Thông tin',
    required_field: 'Trường này là bắt buộc',
    yes: 'Có',
    no: 'Không',
    back: 'Quay lại',
    view_all: 'Xem tất cả',
    profile: 'Hồ sơ',
    signOut: 'Đăng xuất',
    asset: 'Tài sản',
    quantity: 'Số lượng',
    details: 'Chi tiết',
    refresh_data: 'Làm mới',
    refresh_success: 'Đã làm mới dữ liệu',
    refresh_error: 'Làm mới thất bại, vui lòng thử lại'
  },
  home: {
    hero: {
      title: 'Quản Lý Tài Sản Giá Trị Của Bạn Một Cách Tự Tin',
      subtitle: 'Theo dõi vàng, bạc, tiền mặt và ngoại tệ với giá thị trường thời gian thực. Đưa ra quyết định sáng suốt với nền tảng quản lý tài sản toàn diện của chúng tôi.',
      getStarted: 'Bắt Đầu Miễn Phí',
      login: 'Đăng Nhập'
    },
    features: {
      title: 'Tại Sao Chọn Ví Của Tôi?',
      subtitle: 'Nền tảng của chúng tôi cung cấp mọi thứ bạn cần để theo dõi và quản lý tài sản giá trị của mình một cách hiệu quả.',
      realTimeTracking: {
        title: 'Theo Dõi Giá Thời Gian Thực',
        description: 'Cập nhật với thông tin giá hàng giờ cho vàng, bạc và các tài sản khác từ các nguồn đáng tin cậy.'
      },
      transactionHistory: {
        title: 'Lịch Sử Giao Dịch Đầy Đủ',
        description: 'Lưu giữ hồ sơ chi tiết về tất cả các giao dịch mua và bán của bạn với ngày, giá và số lượng chính xác.'
      },
      portfolioAnalytics: {
        title: 'Phân Tích Danh Mục Đầu Tư',
        description: 'Xem giá trị hiện tại và hiệu suất của danh mục đầu tư của bạn với các trực quan hóa trực quan và cập nhật thời gian thực.'
      }
    },
    latestPrices: {
      title: 'Giá Thị Trường Mới Nhất',
      subtitle: 'Luôn cập nhật với giá thị trường mới nhất cho tài sản giá trị của bạn.',
      asset: 'Tài Sản',
      buyPrice: 'Giá Mua',
      sellPrice: 'Giá Bán',
      lastUpdated: 'Cập Nhật Lần Cuối',
      loading: 'Đang tải giá mới nhất...',
      noPriceData: 'Không có dữ liệu giá',
      signUpCta: 'Đăng Ký Để Theo Dõi Tài Sản Của Bạn'
    },
    howItWorks: {
      title: 'Cách Thức Hoạt Động',
      subtitle: 'Bắt đầu với Ví Của Tôi chỉ với một vài bước đơn giản',
      step1: {
        title: 'Đăng Ký',
        description: 'Tạo tài khoản miễn phí của bạn chỉ với tên, số điện thoại và mật khẩu.'
      },
      step2: {
        title: 'Thêm Tài Sản',
        description: 'Ghi lại các giao dịch mua vàng, bạc, tiền mặt hoặc ngoại tệ của bạn.'
      },
      step3: {
        title: 'Theo Dõi Giá',
        description: 'Nhận cập nhật tự động về giá thị trường hiện tại cho tất cả tài sản của bạn.'
      },
      step4: {
        title: 'Giám Sát Giá Trị',
        description: 'Xem giá trị hiện tại của danh mục đầu tư của bạn dựa trên giá thị trường cập nhật.'
      }
    },
    cta: {
      title: 'Sẵn Sàng Bắt Đầu Quản Lý Tài Sản Của Bạn?',
      subtitle: 'Tham gia cùng hàng nghìn người dùng tin tưởng Ví Của Tôi để theo dõi tài sản giá trị của họ.',
      createAccount: 'Tạo Tài Khoản Miễn Phí',
      signIn: 'Đăng Nhập'
    },
    footer: {
      description: 'Theo dõi và quản lý tài sản giá trị của bạn với giá thị trường thời gian thực.',
      quickLinks: 'Liên Kết Nhanh',
      resources: 'Tài Nguyên',
      documentation: 'Tài Liệu',
      faq: 'Câu Hỏi Thường Gặp',
      support: 'Hỗ Trợ',
      contact: 'Liên Hệ',
      email: "nguyenductoan2405{'@'}gmail.com",
      phone: '(+84) 987 802 175',
      copyright: 'Mọi quyền được bảo lưu.'
    }
  },
  auth: {
    login: 'Đăng nhập',
    register: 'Đăng ký',
    username: 'Tên đăng nhập',
    password: 'Mật khẩu',
    confirm_password: 'Xác nhận mật khẩu',
    name: 'Họ và tên',
    forgot_password: 'Quên mật khẩu?',
    no_account: 'Chưa có tài khoản?',
    has_account: 'Đã có tài khoản?',
    create_account: 'Tạo tài khoản',
    invalid_credentials: 'Tên đăng nhập hoặc mật khẩu không hợp lệ',
    logout_success: 'Bạn đã đăng xuất thành công',
    password_mismatch: 'Mật khẩu không khớp',
    registration_success: 'Đăng ký thành công! Bạn có thể đăng nhập ngay bây giờ.',
    remember_me: 'Ghi nhớ đăng nhập',
    password_requirements: 'Mật khẩu phải có ít nhất 6 ký tự'
  },
  dashboard: {
    title: 'Trang chính',
    welcome: 'Xin chào',
    total_assets: 'Tổng tài sản',
    recent_transactions: 'Giao dịch gần đây',
    asset_distribution: 'Phân bổ tài sản',
    assetDistribution: 'Phân bổ tài sản',
    performance: 'Hiệu suất',
    performance_period: 'Khoảng thời gian',
    day: 'Ngày',
    week: 'Tuần',
    month: 'Tháng',
    year: 'Năm',
    all_time: 'Tất cả',
    no_transactions: 'Không có giao dịch gần đây',
    totalAssetsValue: 'Tổng giá trị tài sản',
    assetTypes: 'Loại tài sản',
    transactions: 'Giao dịch',
    yourAssetBalances: 'Số dư tài sản của bạn',
    viewAllBalancesDescription: 'Xem tất cả số dư tài sản hiện tại và giá trị của chúng.',
    noAssets: 'Không có tài sản',
    getStartedMessage: 'Bắt đầu bằng cách thêm giao dịch tài sản đầu tiên của bạn.',
    addTransaction: 'Thêm giao dịch',
    currentPrice: 'Giá hiện tại',
    totalValue: 'Tổng giá trị',
    noAssetDataAvailable: 'Không có dữ liệu tài sản',
    savingAssetsByTime: 'Tiết kiệm tài sản theo thời gian',
    noTransactionDataAvailable: 'Không có dữ liệu giao dịch trong 12 tháng qua',
    creditsBuy: 'Mua vào',
    debitsSell: 'Bán ra',
    credits: 'Mua vào',
    debits: 'Bán ra',
    unrealizedGain: 'Lãi tạm tính'
  },
  assets: {
    title: 'Tài sản',
    my_assets: 'Tài sản của tôi',
    market_price: 'Giá thị trường',
    current_value: 'Giá trị hiện tại',
    buy_price: 'Giá mua',
    sell_price: 'Giá bán',
    unit: 'Đơn vị',
    quantity: 'Số lượng',
    no_assets: 'Bạn chưa có tài sản nào',
    refresh_prices: 'Cập nhật giá',
    current_market_prices: 'Giá thị trường hiện tại',
    your_portfolio: 'Danh mục đầu tư của bạn',
    no_asset_prices: 'Không có giá tài sản nào',
    no_portfolio_assets: 'Không có tài sản nào trong danh mục của bạn',
    updated_at: 'cập nhật lúc',
    unrealizedGain: 'Lãi tạm tính',
    returnOnInvestment: 'ROI'
  },
  transactions: {
    title: 'Giao dịch',
    my_transactions: 'Giao dịch của tôi',
    make_transaction: 'Tạo giao dịch',
    buy: 'Mua',
    sell: 'Bán',
    date: 'Ngày',
    asset: 'Tài sản',
    price: 'Giá',
    quantity: 'Số lượng',
    total: 'Tổng',
    type: 'Loại',
    credit: 'Nạp vào',
    debit: 'Rút ra',
    description: 'Mô tả',
    filter_by_date: 'Lọc theo ngày',
    filter_by_asset: 'Lọc theo tài sản',
    filter_by_type: 'Lọc theo loại',
    transaction_success: 'Giao dịch hoàn tất thành công',
    no_transactions: 'Không tìm thấy giao dịch nào',
    from_date: 'Từ ngày',
    to_date: 'Đến ngày',
    apply_filters: 'Áp dụng bộ lọc',
    clear_filters: 'Xóa bộ lọc',
    new_transaction: 'Giao dịch mới',
    filters: 'Bộ lọc',
    hide_filters: 'Ẩn bộ lọc',
    show_filters: 'Hiển thị bộ lọc',
    filter_description: 'Mặc định, các giao dịch trong 365 ngày qua được hiển thị. Sử dụng bộ lọc để thu hẹp tìm kiếm của bạn.',
    all_assets: 'Tất cả tài sản',
    all_types: 'Tất cả loại',
    reset: 'Đặt lại',
    refresh: 'Làm mới',
    transaction_history: 'Lịch sử giao dịch',
    loading_transactions: 'Đang tải giao dịch...',
    transaction_type: 'Loại giao dịch',
    select_asset: 'Chọn tài sản',
    select_price: 'Chọn giá',
    recent_prices: 'Hiển thị giá trong 30 ngày gần đây',
    transaction_date: 'Ngày giao dịch',
    date_time_note: 'Chọn ngày giao dịch xảy ra. Thời gian sẽ được tự động thêm vào.',
    optional: 'Tùy chọn',
    transaction_summary: 'Tổng kết giao dịch',
    price_date: 'Ngày giá',
    total_value: 'Tổng giá trị',
    submit_transaction: 'Gửi giao dịch',
    processing: 'Đang xử lý...'
  },
  profile: {
    title: 'Hồ sơ',
    personal_info: 'Thông tin cá nhân',
    change_password: 'Đổi mật khẩu',
    current_password: 'Mật khẩu hiện tại',
    new_password: 'Mật khẩu mới',
    confirm_new_password: 'Xác nhận mật khẩu mới',
    update_profile: 'Cập nhật hồ sơ',
    update_password: 'Cập nhật mật khẩu',
    profile_updated: 'Hồ sơ đã được cập nhật thành công',
    password_updated: 'Mật khẩu đã được cập nhật thành công',
    incorrect_password: 'Mật khẩu hiện tại không đúng',
    password_must_be_different: 'Mật khẩu mới phải khác với mật khẩu hiện tại'
  },
  errors: {
    something_went_wrong: 'Đã xảy ra lỗi',
    network_error: 'Lỗi kết nối mạng. Vui lòng kiểm tra kết nối và thử lại.',
    unauthorized: 'Bạn không được phép truy cập tài nguyên này',
    session_expired: 'Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.',
    validation_error: 'Vui lòng kiểm tra biểu mẫu để sửa lỗi',
    not_found: 'Không tìm thấy tài nguyên yêu cầu'
  },
  languages: {
    en: 'Tiếng Anh',
    vi: 'Tiếng Việt'
  }
}